import { apiRoutes } from './apiRoutes'
import { apiCall } from './apiService/apiCall'

const loginApi = (userData) => apiCall(apiRoutes.login, 'post', userData)
const currentUserApi = () => apiCall(apiRoutes.currentUser, 'get')
const uploadFileApi = (data) => apiCall(apiRoutes.upload, 'post', data, 'multipart/form-data')
const getCustomersApi = (limit=10, page=0, search='', type) => apiCall(`${apiRoutes.customers}?limit=${limit}&offset=${page}&q=${search}&expand=billing_address,groups&groups[]=${type}`, 'get')
const getCustomersGroupsApi = (query) => apiCall(`${apiRoutes.customerGroups}?q=${query}`, 'get')
const getCustomersByGroupsApi = (id, limit=10, page=0, search='') => apiCall(`${apiRoutes.customerGroups}/${id}/customers?limit=${limit}&offset=${page}&q=${search}&expand=shipping_addresses,billing_address`, 'get')
const getCustomerByIdApi = (id) => apiCall(`${apiRoutes.customers}/${id}`, 'get')
const getTeamsRole = () => apiCall(apiRoutes.teams, 'get')
const addTeamRole = (data) => apiCall(apiRoutes.teams, 'post', data)
const getTeamMembers = () => apiCall(`${apiRoutes.team}`, 'get') 
const addTeamMember = (data) => apiCall(`${apiRoutes.team}`, 'post', data)
const getTeamMemberById = (id) => apiCall(`${apiRoutes.team}/${id}`, 'get')
const updateTeamMember = (id, data) => apiCall(`${apiRoutes.team}/${id}`, 'post', data)
const updateTeams = (data) => apiCall(`${apiRoutes.updateTeams}`, 'post', data) 
const deleteTeamMember = (id) => apiCall(`${apiRoutes.team}/${id}`, 'delete')
const getProductCategoriesApi = () => apiCall(`${apiRoutes.productCategories}`, 'get')
const addProductCategoryApi = (data) => apiCall(apiRoutes.productCategories, 'post', data)
const getProductCategorysByIdApi = (id) => apiCall(`${apiRoutes.productCategories}/${id}?expand=products`, 'get')
const getProductsApi = (cat_id, limit=10, page=0, search='', sort='title') => apiCall(`${apiRoutes.products}?category_id[]=${cat_id}&include_category_children=true&limit=${limit}&offset=${page}&q=${search}&order=${sort.name}`, 'get')
const addProductApi = (data) => apiCall(apiRoutes.products, 'post', data)
const updateProductApi = (id, data) => apiCall(`${apiRoutes.products}/${id}`, 'post', data)
const updateProductMetadataApi = (id, data) => apiCall(`${apiRoutes.products}/${id}/metadata`, 'post', data)
const deleteProductApi = (id) => apiCall(`${apiRoutes.products}/${id}`, 'delete')
const getOrdersApi = (limit=10, page=0, search='', status, id) => apiCall(`${apiRoutes.orders}?limit=${limit}&offset=${page}&status[]=${status}&expand=customer,cart,shipping_address,billing_address,shipping_methods,items,fulfillments,payments${search ? `&q=${search}` : ''}${id ? `&customer_id=${id}` : ''}`, 'get')
const capturePaymentApi = (id) => apiCall(`${apiRoutes.orders}/${id}/capture`, 'post')
const createFulfillmentApi = (id, data) => apiCall(`${apiRoutes.orders}/${id}/fulfillment`, 'post', data)
const shipOrderApi = (id, data) => apiCall(`${apiRoutes.orders}/${id}/shipment`, 'post', data)
const completeOrderApi = (id) => apiCall(`${apiRoutes.orders}/${id}/complete`, 'post')
const generatePDFApi = (type, id) => apiCall(`${apiRoutes.generatePDF}/?type=${type}&id=${id}`, 'get')
const getInventoryProductsApi = (limit=10, page=0, search='') => apiCall(`${apiRoutes.inventoryProducts}?limit=${limit}&offset=${page}&q=${search}`, 'get')
const updateProductVariantsApi = (id, variant_id, data) => apiCall(`${apiRoutes.products}/${id}/variants/${variant_id}`, 'post', data)
const getThermofisherProductsApi = (limit=10, page=0, search='') => apiCall(`${apiRoutes.thermofisherProducts}?limit=${limit}&offset=${page}&q=${search}`, 'get')
const getAdminUsersApi = (limit=10, page=0, search='') => apiCall(`${apiRoutes.users}?limit=${limit}&offset=${page}&q=${search}`, 'get')
const addAdminUserApi = (data) => apiCall(apiRoutes.users, 'post', data)
const updateAdminUserApi = (id, data) => apiCall(`${apiRoutes.users}/${id}`, 'post', data)
const deleteAdminUserApi = (id) => apiCall(`${apiRoutes.users}/${id}`, 'delete')
const requestTokenAdminUserApi = (data) => apiCall(`${apiRoutes.users}/password-token`, 'post', data)
const resetPasswordAdminUserApi = (data) => apiCall(`${apiRoutes.users}/reset-password`, 'post', data)
const getRolesApi = (limit=10, page=0, search='') => apiCall(`${apiRoutes.roles}?limit=${limit}&offset=${page}&q=${search}`, 'get')
const addRoleApi = (data) => apiCall(apiRoutes.roles, 'post', data)
const updateRoleApi = (id, data) => apiCall(`${apiRoutes.roles}/${id}`, 'post', data)
const deleteRoleApi = (id) => apiCall(`${apiRoutes.roles}/${id}`, 'delete')
const getRoleByIdApi = (id) => apiCall(`${apiRoutes.roles}/${id}`, 'get')
const assignRoleToUserApi = (role_id, user_id) => apiCall(`${apiRoutes.roles}/${role_id}/user/${user_id}`, 'post')
const getPermissionsApi = () => apiCall(apiRoutes.permissions, 'get')
const updatePermissionApi = (id, data) => apiCall(`${apiRoutes.permissions}/${id}`, 'post', data)
const deletePermissionApi = (id) => apiCall(`${apiRoutes.permissions}/${id}`, 'delete')
const getTemplatesApi = (limit=30, page=0) => apiCall(`${apiRoutes.templates}?limit=${limit}&offset=${page}`, 'get')
const addTemplateApi = (data) => apiCall(apiRoutes.templates, 'post', data)
const updateTemplateApi = (id, data) => apiCall(`${apiRoutes.templates}/${id}`, 'post', data)
const deleteTemplateApi = (id) => apiCall(`${apiRoutes.templates}/${id}`, 'delete')
const getTemplatesCategoriesApi = (limit, page = 0, search) => {
  const params = new URLSearchParams();

  if (limit) params.append('limit', limit);
  if (page) params.append('offset', page);
  if (search) params.append('search', search);

  const query = params.toString();
  const url = query
    ? `${apiRoutes.templatesCategory}?${query}`
    : apiRoutes.templatesCategory;

  return apiCall(url, 'get');
};
const addTemplateCategoryApi = (data) => apiCall(apiRoutes.templatesCategory, 'post', data)
const updateTemplateCategoryApi = (id, data) => apiCall(`${apiRoutes.templatesCategory}/${id}`, 'post', data)
const deleteTemplateCategoryApi = (id) => apiCall(`${apiRoutes.templatesCategory}/${id}`, 'delete')

export {
loginApi,
currentUserApi,
uploadFileApi,
getCustomersApi,
getCustomersGroupsApi,
getCustomersByGroupsApi,
getCustomerByIdApi,
getTeamsRole,
addTeamRole,
getTeamMembers,
addTeamMember,
getTeamMemberById,
updateTeamMember,
updateTeams,
deleteTeamMember,
getProductCategoriesApi,
addProductCategoryApi,
getProductCategorysByIdApi,
getProductsApi,
addProductApi,
updateProductApi,
deleteProductApi,
getOrdersApi,
capturePaymentApi,
createFulfillmentApi,
shipOrderApi,
completeOrderApi,
generatePDFApi,
getInventoryProductsApi,
updateProductVariantsApi,
getThermofisherProductsApi,
updateProductMetadataApi,
getAdminUsersApi,
addAdminUserApi,
updateAdminUserApi,
deleteAdminUserApi,
requestTokenAdminUserApi,
resetPasswordAdminUserApi,
getRolesApi,
addRoleApi,
updateRoleApi,
deleteRoleApi,
assignRoleToUserApi,
getRoleByIdApi,
getPermissionsApi,
updatePermissionApi,
deletePermissionApi,
getTemplatesApi,
addTemplateApi,
updateTemplateApi,
deleteTemplateApi,
getTemplatesCategoriesApi,
addTemplateCategoryApi,
updateTemplateCategoryApi,
deleteTemplateCategoryApi
}
